import styled from 'styled-components';

import { media } from '../../helpers/breakpoints';

const Container = styled.div`
  margin: ${({ theme }) => `${theme.spacing.M24} 0`};

  ${media.medium} {
    margin: ${({ theme }) => `${theme.spacing.M32} 0`};
  }
`;

const Title = styled.h1`
  ${({ theme }) => theme.fontSize.H24};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  margin-bottom: ${({ theme }) => theme.spacing.M24};

  ${media.medium} {
    margin-bottom: ${({ theme }) => theme.spacing.L48};
  }
`;

const SectionTitle = styled.h2`
  ${({ theme }) => theme.fontSize.L18};
`;

const Sections = styled.ul`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacing.M24};

  ${media.medium} {
    grid-gap: ${({ theme }) => theme.spacing.L48};
  }
`;

const Subsections = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ theme }) => theme.spacing.S12};
  margin-top: ${({ theme }) => theme.spacing.M16};

  ${media.medium} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const ListItem = styled.li`
  ${({ theme }) => theme.fontSize.M14};
`;

export { Container, Title, SectionTitle, Sections, Subsections, ListItem };
